"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var DisabledBubbleMessage_1 = tslib_1.__importDefault(require("../DisabledBubbleMessage"));
var translations_1 = require("../../utils/translations");
var CheckboxControl = /** @class */ (function (_super) {
    tslib_1.__extends(CheckboxControl, _super);
    function CheckboxControl(props) {
        var _this = _super.call(this, props) || this;
        _this.onValueChanged = _this.onValueChanged.bind(_this);
        return _this;
    }
    CheckboxControl.prototype.render = function () {
        var _a = this.props, checked = _a.checked, disabled = _a.disabled, labelText = _a.labelText, showDisabledMessage = _a.showDisabledMessage, intl = _a.intl;
        return (react_1.default.createElement(DisabledBubbleMessage_1.default, { showDisabledMessage: showDisabledMessage },
            react_1.default.createElement("label", { className: "input-checkbox-label" },
                react_1.default.createElement("input", { checked: checked, disabled: disabled, type: "checkbox", className: "input-checkbox", onChange: this.onValueChanged }),
                react_1.default.createElement("span", { className: "input-label-text" }, translations_1.getTranslation(labelText, intl)))));
    };
    CheckboxControl.prototype.onValueChanged = function (event) {
        var _a = this.props, valuePath = _a.valuePath, properties = _a.properties, pushData = _a.pushData;
        var clonedProperties = cloneDeep_1.default(properties);
        set_1.default(clonedProperties, "controls." + valuePath, event.target.checked);
        pushData({ properties: clonedProperties });
    };
    CheckboxControl.defaultProps = {
        checked: false,
        disabled: false,
        showDisabledMessage: false,
    };
    return CheckboxControl;
}(react_1.default.Component));
exports.default = react_intl_1.injectIntl(CheckboxControl);
//# sourceMappingURL=CheckboxControl.js.map